module.exports = __webpack_public_path__ + "media/signing.c7ad8acc.mp4";